module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.94dac78e.woff";